const CLEAR_CSV_UPLOAD_STATE = 'app/Segment/CLEAR_CSV_UPLOAD_STATE';

type Types = {
  CLEAR_CSV_UPLOAD_STATE: typeof CLEAR_CSV_UPLOAD_STATE;
};

const types: Types = {
  CLEAR_CSV_UPLOAD_STATE,
};

/* Actions */
type ClearCSVUploadState = () => {
  type: typeof CLEAR_CSV_UPLOAD_STATE;
};

export type Action = ReturnType<ClearCSVUploadState>;

export type ActionCreators = {
  ClearCSVUploadState: ClearCSVUploadState;
};

export type State = {
  uploading: false;
};

export default types;
